import React, { useState, useEffect } from "react";
import { httpRequest } from "@/utils/HttpRequest";
import "./home.less";
import Flag01 from "@/assets/images/flag01.png"
import Flag02 from "@/assets/images/flag02.png"
import Flag03 from "@/assets/images/flag03.png"
import HomeIcon01 from "@/assets/images/home-icon-01.png"
import HomeIcon02 from "@/assets/images/home-icon-02.png"
import HomeIcon03 from "@/assets/images/home-icon-03.png"
import HomeIcon04 from "@/assets/images/home-icon-04.png"
import HomeIcon05 from "@/assets/images/home-icon-05.png"
import { Select } from "antd";
import { statisticalType, homeService, approvalList, IHomeSearch, ICrawlerCurrencyList, IWarningList } from "./homeService"
import moment from 'moment';
import { useDictModel } from "@/views/base/dict/dictModel";
import { ISelectOption } from '@/components/YhFormBox/Types';
import useGlobalModel from '@/model/globalModel';
import { momentFormat} from "@/utils/utils";
import { overflow } from "html2canvas/dist/types/css/property-descriptors/overflow";


interface IHomeData {
    data?: string;
    time?: string;
    week?: string;
}

interface IHomePrice {
    buyingRate: string | number  // 现汇买入
}

export function Home() {
    const initStatistic = {
        inquiryNum: 0,
        offerNum: 0,
        saleNum: 0,
        purchaseNum: 0,
        shipmentNum: 0
    }

    const initData = {
        data: '',
        time: '',
        week: ''
    }

    const initRate = {
        buyingRate: 0,
    }
    const { user: { shopCode } } = useGlobalModel(({ user }) => [user]);
    const { getTreeNodeValue } = useDictModel();
    // 北京时间
    const [bjTime, setBjTime] = useState<IHomeData>(initData)
    // 沙特时间
    const [stTime, setStTime] = useState<IHomeData>(initData)
    const [nrTime, setNrTime] = useState<IHomeData>(initData)
    // 统计分析
    const [statistical, setStatistical] = useState<statisticalType>(initStatistic)
    // 外汇牌价
    const [priceData, setPriceData] = useState<ICrawlerCurrencyList[]>([])
    // 审核中心
    const [approvalData, setApprovalData] = useState<approvalList[]>([])
    // 币种默认值
    const [defaultValues, setDefaultValues] = useState<string>('')
    // 汇率
    const [priceRate, setPriceRate] = useState<IHomePrice>(initRate)
    // 提醒中心
    const [warningList, setWarningList] = useState<IWarningList[]>([])
    // 提醒中心 未收款预警
    const [warningPurchaseList, setWarningPurchaseList] = useState<IWarningList[]>([])//采购合同
    const [warningSaleList, setWarningSaleList] = useState<IWarningList[]>([])//外贸合同

    // 获取统计分析数据
    const loadData = async () => {
        let { retData } = await homeService.statistical()
        setStatistical(retData)
    }

    // 数组去重
    const containsDuplicate = (nums: any[]) => {
        let result: any = [];
        let obj: any = {};
        for (let i = 0; i < nums.length; i++) {
            if (!obj[nums[i].currencyName]) {
                result.push(nums[i]);
                obj[nums[i].currencyName] = true;
            }
        }
        return result
    }

    // 获取外汇牌价
    const getPriceList = async () => {
        let { retData } = await homeService.crawlerCurrency()
        let newData = retData.map(item => {
            return {
                ...item,
                label: item.currencyName,
                value: item.currencyName
            }
        })
        let newReords = containsDuplicate(newData)
        let filter = retData.filter(item => item.currencyName === '美元')
        let defaultPrice = {
            buyingRate: filter[0]?.buyingRate as string ?? 665.95,
        }
        setPriceRate(defaultPrice)
        setPriceData(newReords)
    }

    // 获取审核中心数据
    const loadApproval = async (searchValue: IHomeSearch) => {
        let data = {
            ...searchValue,
            // shopCode,
            page: {
                "pageSize": 5,
                "pageNum": 1
            }
        }
        let { retData } = await homeService.approvalPage(data)
        let { records } = retData
        let newData = records.map(item => {
            return {
                ...item,
                createTime: moment(item.createTime).format("YYYY-MM-DD HH:mm:ss")
            }
        })
        setApprovalData(newData)
    }

    // 时间装换
    const changeTime = (oldTime: string, date: number) => {
        let newTime: string
        let oldSecond = (new Date(oldTime)).getTime()
        // 将预警天数转换为毫秒数
        let warningSecond = Number(date) * 24 * 3600000
        let newSecond = oldSecond 
        newTime = moment(newSecond).format("YYYY-MM-DD")
        return newTime
    }

    // 获取提醒中心
    // const getWarningData = async () => {
    //     let data = {
    //         // shopCode,
    //         page: {
    //             "pageSize": 5,
    //             "pageNum": 1
    //         }
    //     }
    //     let { retData } = await homeService.warning(data)
    //     let { records } = retData
    //     let newData = records.map(item => {
    //         return {
    //             ...item,
    //             estimatedTime: moment(item.estimatedTime).format("YYYY-MM-DD HH:mm:ss"),
    //             warningData: changeTime(item.estimatedTime as string, Number(item.warningTime))
    //         }
    //     })
    //     setWarningList(newData)
    // }
    // 获取提醒中心 未收款预警
     const getWarningData = async () => {
        let { retData } = await homeService.payWaring({
            shopCode,
			pageSize:9999,
			pageNum:1 ,
        })
        let { records } = retData
        let newData:any = []
        let list:any =[]
        if (records) {
          newData = records.filter(obj => obj.uncollected !==undefined ||obj.uncollected!=='');
          list=newData.filter((item:any)=>{
           // debugger
           return  item.uncollected >100
          })
        } 
        setWarningSaleList(list)
      homeService.paymentWaring({shopCode,pageSize:9999,pageNum:1}).then(({retData})=>{
        let paymentData:any=[]  
        let {records} =retData
        if (records) {
            paymentData = records.map((item) => {
                return {
                    ...item,
                    waitAmount: ((item.amountTotal as number) -(item.countPrice as number)).toFixed(2),
                };
            }).filter((item:any)=> item.waitAmount!=='0.00');
            console.log(paymentData)
          }
        // console.log('paymentData',paymentData,'list',list)
        // let total=paymentData.concat(list)
        // console.log(total)
        // setWarningPurchaseList(total);
        setWarningPurchaseList(paymentData);
      })
     

    }


    // 时间设置
    const getLocalTime = (i: number) => {
        if (typeof i !== "number") {
            return new Date();
        }
        var d = new Date();
        var len = d.getTime();
        var offset = d.getTimezoneOffset() * 60000;
        var utcTime = len + offset;
        return new Date(utcTime + 3600000 * i);
    }
    // 北京时间
    let bjtimezone = 8 // 北京时区
    // 沙特时区
    let sttimezone = 3
    // 尼日时区
    let nrtimezon = 1
    let bjData: any
    let stData: any
    let nrData: any
    bjData = getLocalTime(bjtimezone).toString().split("GMT+")[0].toString();
    stData = getLocalTime(sttimezone).toString().split("GMT+")[0].toString();
    nrData = getLocalTime(nrtimezon).toString().split("GMT+")[0].toString();

    const dateFormat = (dateData: string) => {
        const nowTime = moment(dateData).format('YYYY-MM-DD HH:mm:ss')
        const week = getWeek(nowTime)
        const data = nowTime.slice(0, 10)
        const time = nowTime.slice(11)
        let obj = {
            data,
            week,
            time
        }
        return obj
    }

    const getWeek = (date: string) => { // 参数时间戳
        let week = moment(date).day()
        switch (week) {
            case 1:
                return '星期一'
            case 2:
                return '星期二'
            case 3:
                return '星期三'
            case 4:
                return '星期四'
            case 5:
                return '星期五'
            case 6:
                return '星期六'
            case 0:
                return '星期日'
        }
    }
    useEffect(() => {
        loadData()
        loadApproval({})
        getPriceList()
        getWarningData()
        let timers: NodeJS.Timeout;
        timers = setInterval(() => {
            bjData = getLocalTime(bjtimezone).toString().split("GMT+")[0].toString();
            stData = getLocalTime(sttimezone).toString().split("GMT+")[0].toString();
            nrData = getLocalTime(nrtimezon).toString().split("GMT+")[0].toString();
            setBjTime(dateFormat(bjData))
            setStTime(dateFormat(stData))
            setNrTime(dateFormat(nrData))
        }, 1000)
        return () => {
            clearInterval(timers);
        }
    }, [])

    // 币种切换
    const onPriceChang = (value: string, option: ISelectOption) => {
        if (value && option) {
            let rate = {
                buyingRate: option.buyingRate,
                sellingRate: option.sellingRate
            }
            setPriceRate(rate)
        };

    }

    const ListItem = ({ type, status, result, title, time }: { type: 'msg' | 'warn', status?: number, result?: number, title: any, time?: any }) => {
        return <div className={`home-list-item cur-pointer flex items-center justify-between ${status === 1 && 'readed'} ${result === 1 && 'pass'}`}>
            <div className="home-list-item__content one-line">
                <span>{title}</span>
                {
                    type === 'msg' && <>
                        <span>，</span>
                        <span className="home-list-item__result" style={{ color: status === 1 ? "#FA1E3B" : "#55CE95" }}>{status === 1 ? "审批已驳回" : "审批通过"}</span>
                    </>
                }
            </div>
            {/* {
                type === 'msg' && <>
                    <div className="flex items-center home-list-item__status">
                        <div className="home-list-dot inline-block" />
                        <span>{status === 1 ? "已读" : "未读"}</span>
                    </div>
                </>
            } */}
            <span className="home-list-item__time">{time}</span>
        </div>
    }
    return (
        <div className="home">
            <div className="flex">
                {/* 各国时间 */}
                <div className="home-box home-left-box home-time flex justify-between">
                    <div className="home-time-item">
                        <img className="home-time-item__img" src={Flag01} alt="" />
                        <div className="flex-col justify-between">
                            <span className="home-time-item__add">中国时间</span>
                            <span className="home-time-item__time">{bjTime.time}</span>
                            <span className="home-time-item__time2">{bjTime.data}&nbsp;{bjTime.week}</span>
                        </div>
                    </div>
                    <div className="home-time-item">
                        <img className="home-time-item__img" src={Flag02} alt="" />
                        <div className="flex-col justify-between">
                            <span className="home-time-item__add">沙特时间</span>
                            <span className="home-time-item__time">{stTime.time}</span>
                            <span className="home-time-item__time2">{stTime.data}&nbsp;{stTime.week}</span>
                        </div>
                    </div>
                    <div className="home-time-item">
                        <img className="home-time-item__img" src={Flag03} alt="" />
                        <div className="flex-col justify-between">
                            <span className="home-time-item__add">尼日利亚时间</span>
                            <span className="home-time-item__time">{nrTime.time}</span>
                            <span className="home-time-item__time2">{nrTime.data}&nbsp;{nrTime.week}</span>
                        </div>
                    </div>
                </div>
                {/* 当前汇率 */}
                <div className="home-box home-right-box home-rate">
                    <div className="flex">
                        <span className="home-box__title">外汇牌价</span>
                    </div>

                    <div className="flex home-rate-table">
                        <span className="home-rate-table__one">货币名称</span>
                        <span className="home-rate-table__two">购汇买入价</span>
                        {/* <span className="home-rate-table__three">执行汇率</span> */}
                    </div>
                    <div className="flex home-rate-table">
                        <div className="home-rate-table__one">
                            美元
                            {/* <Select
                                defaultValue={defaultValues}
                                placeholder="币种"
                                style={{ width: '150px', margin: '-10px 0' }}
                                onChange={(value: string, options: any) => onPriceChang(value, options as ISelectOption)}
                                options={priceData as any}
                                key={defaultValues}
                            /> */}
                        </div>
                        <span className="home-rate-table__two">{priceRate.buyingRate}</span>
                        {/* <span className="home-rate-table__three">{priceRate.buyingRate}</span> */}
                    </div>
                </div>
            </div>
            {/* 统计信息 */}
            <div className="flex home-statis">
                <div className="home-box flex items-center home-statis-item">
                    <img width={72} height={72} src={HomeIcon01} alt="" />
                    <div className="flex-col justify-center">
                        <span className="home-statis-item__value">{statistical.inquiryNum}</span>
                        <span className="home-statis-item__title">本月询价</span>
                    </div>
                </div>
                <div className="home-box flex items-center home-statis-item">
                    <img width={72} height={72} src={HomeIcon02} alt="" />
                    <div className="flex-col justify-center">
                        <span className="home-statis-item__value">{statistical.offerNum}</span>
                        <span className="home-statis-item__title">本月报价</span>
                    </div>
                </div>
                <div className="home-box flex items-center home-statis-item">
                    <img width={72} height={72} src={HomeIcon03} alt="" />
                    <div className="flex-col justify-center">
                        <span className="home-statis-item__value">{statistical.saleNum}</span>
                        <span className="home-statis-item__title">本月销售</span>
                    </div>
                </div>
                <div className="home-box flex items-center home-statis-item">
                    <img width={72} height={72} src={HomeIcon04} alt="" />
                    <div className="flex-col justify-center">
                        <span className="home-statis-item__value">{statistical.purchaseNum}</span>
                        <span className="home-statis-item__title">本月采购</span>
                    </div>
                </div>
                <div className="home-box flex items-center home-statis-item">
                    <img width={72} height={72} src={HomeIcon05} alt="" />
                    <div className="flex-col justify-center">
                        <span className="home-statis-item__value">{statistical.shipmentNum}</span>
                        <span className="home-statis-item__title">本月出运</span>
                    </div>
                </div>
            </div>
            <div className="flex" style={{ flexWrap: "wrap" }}>
                {/* 审批中心 */}
                <div className="home-box home-left-box" style={{marginBottom:"10px"}}>
                    <div className="flex">
                        <span className="home-box__title">审批中心</span>
                    </div>
                    <div className="home-list">
                        {approvalData.map((item, index) => {
                            return <ListItem
                                key={item.id}
                                type="msg"
                                status={item.status as number}
                                result={0}
                                title={`审批人【${item.auditUser}】将单据号为${item.code}的${item.auditProject}`}
                                time={moment(item.createTime).format('YYYY-MM-DD')}
                            ></ListItem>
                        })}
                        {/* <div className="home-list-footer flex justify-center">
                            <div className="home-list-footer__button cur-pointer">
                                查看更多
                            </div>
                        </div> */}
                    </div>
                </div>
                {/* 提醒中心 */}
                <div className="home-box home-right-box" style={{marginBottom:"10px", height:'400px',overflow:'auto'}}>
                    <div className="flex">
                        <span className="home-box__title">提醒中心</span>
                    </div>
                    <div className="home-list">

                        {/* {warningList.map((item, index) => {
                            return <ListItem
                                key={item.id}
                                type="warn"
                                title={`${item.code}: 在【${item.warningData}】${item.warningName}还有${item.warningTime}天到期`}
                            ></ListItem>
                        })} */}
                        {warningPurchaseList.map((item, index) => {
                            return <ListItem
                                key={item.id}
                                type="warn"  
                                title={item.uncollected ? `${item.realCode}：未收金额为${item.uncollected}元 预计收款时间为${moment(item.estimatedTime).format('YYYY-MM-DD')}`:`${item.purchaseCode}: 未付款金额为${item.waitAmount}元 预计付款时间为${moment(item.estimatedTime).format('YYYY-MM-DD')}`}
                            ></ListItem>
                        })}
                        {warningSaleList.map((item, index) => {
                            return <ListItem
                                key={item.id}
                                type="warn"  
                                title={item.uncollected ? `${item.realCode}：未收金额为${ getTreeNodeValue(item.currencyCode)}${item.uncollected} 预计收款时间为${moment(item.estimatedTime).format('YYYY-MM-DD')}`:`${item.purchaseCode}: 未付款金额为${ getTreeNodeValue(item.currencyCode)}${item.waitAmount} 预计付款时间为${moment(item.estimatedTime).format('YYYY-MM-DD')}`}
                            ></ListItem>
                        })}
                        {/* <div className="home-list-footer flex justify-center">
                            <div className="home-list-footer__button cur-pointer">
                                查看更多
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        </div >
    )
}